import React from 'react';
import './ProfileCard.css';
import { FaGithub, FaLinkedin } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

function ProfileCard({ image, name, birthdate, location, company, position, education, links = [] }) {
  // Function to get the icon based on link name
  const getLinkIcon = (linkName) => {
    switch(linkName.toLowerCase()) {
      case 'github':
        return <FaGithub className="link-icon" />;
      case 'linkedin':
        return <FaLinkedin className="link-icon" />;
      case 'email':
        return <MdEmail className="link-icon" />;
      default:
        return null;
    }
  };

  // Calculate age from birthdate
  // const calculateAge = () => {
  //   if (!birthdate) return '';
  //   const [day, month, year] = birthdate.split('.');
  //   const birthDate = new Date(year, month - 1, day);
  //   const today = new Date();
  //   let age = today.getFullYear() - birthDate.getFullYear();
  //   const monthDiff = today.getMonth() - birthDate.getMonth();
  //   if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
  //     age--;
  //   }
  //   return age;
  // };

  return (
    <div className="profile-card">
      <div className="profile-image-container">
        <img 
          src={image} 
          alt={name}
          className="profile-image" 
          loading="eager" 
          width="150" 
          height="150"
        />
        {links.length > 0 && (
          <div className="profile-links">
            {links.map((link, index) => (
              <a 
                key={index} 
                href={link.url} 
                className="profile-link"
                target={link.isExternal ? "_blank" : undefined}
                rel={link.isExternal ? "noopener noreferrer" : undefined}
                aria-label={link.name}
                title={link.name}
              >
                {getLinkIcon(link.name)}
              </a>
            ))}
          </div>
        )}
      </div>
      <div className="profile-info">
        {/* Name displayed prominently */}
        <div className="info-item-name">{name}</div>
        
        <div className="info-section">
          <div className="info-item">
            <span className="info-label">💼 Position:</span> {position}
          </div>
          <div className="info-item">
            <span className="info-label">🏢 Company:</span> {company}
          </div>
          <div className="info-item">
            <span className="info-label">📍 Location:</span> {location}
          </div>
          <div className="info-item">
            <span className="info-label">🎓 Education:</span> {education}
          </div>
          {/* <div className="info-item">
            <span className="info-label">🎂 Age:</span> {calculateAge()}
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default ProfileCard; 